module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-panel"
  }, [_c('div', {
    staticClass: "z-panel__header"
  }, [_vm._t("header", [_c('h4', {
    staticClass: "z-panel__title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), (_vm.desc) ? _c('span', {
    staticClass: "z-panel__desc",
    domProps: {
      "textContent": _vm._s(_vm.desc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.status) ? _c('span', {
    staticClass: "z-panel__status",
    domProps: {
      "textContent": _vm._s(_vm.status)
    }
  }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "z-panel__content"
  }, [_vm._t("default")], 2), _vm._v(" "), (this.$slots.footer) ? _c('div', {
    staticClass: "z-panel__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c1e6335!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/panel/src/panel.vue
// module id = 140
// module chunks = 2 3